import * as React from 'react';

interface PVAContentHeaderProps {
    sticky?: string;
}

export class PVAContentHeader extends React.Component<PVAContentHeaderProps> {
    public render() {
        return (
            <div className={this.props.sticky === 'sticky' ? 'navbar-padding' : ''}>
                <div className={'content-header' + (this.props.sticky === 'sticky' ? ' navbar-sticky' : '')}>
                    <div className="content-container">
                        {this.props.children}
                    </div>
                </div>
            </div> );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/PVAContentHeader.tsx